module.exports = __webpack_public_path__ + "img/about_client.9d1ebdfd.jpg";